import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@ixicare/ui';
import connect from '~/store/connect';
import UserNotifications from '~components/Notifications/UserNotifications';
import SiteStore from '../store/Site';
import store from '~store';

export interface SiteWrapperProps {
  site: SiteStore;
}

const siteWrapper = (Component, getInitialProps?: (props: any) => any) => {
  const WrappedComponent = ({ sites, loadSites, sitesLoaded, ...props }) => {
    const { id, planeId } = useParams<{ id: string; planeId?: string }>();
    const parsedPlaneId = planeId ? parseInt(planeId, 10) : undefined;

    React.useEffect(() => {
      if (!sitesLoaded) {
        loadSites();
      }
    }, [sitesLoaded, loadSites]);

    const site = React.useMemo(() => {
      return sites.find((s) => s.uuid === id);
    }, [sites, id]);

    // Set the selected site in the store when viewing a site
    React.useEffect(() => {
      if (site) {
        store.sites.setSelectedSiteUuid(site.uuid);
      }
    }, [site]);

    if (!site) {
      return <Spinner label={'Loading'} />;
    }

    const additionalProps = getInitialProps ? getInitialProps({ query: { id, planeId } }) : {};

    return (
      <UserNotifications>
        <Component {...props} {...additionalProps} site={site} siteId={site.id} planeId={parsedPlaneId} />
      </UserNotifications>
    );
  };

  return connect((state: any) => ({
    sites: state.sites.sites,
    loadSites: state.sites.loadSites,
    sitesLoaded: state.sites.loaded,
  }))(WrappedComponent);
};

export default siteWrapper;
